// TODO - Documentar
// Transaction Summary Hook
import {useCallback, useEffect, useState} from 'react'
import { useSelector } from 'react-redux'

import * as con from "../../GlobalConstants"
import { processTransactionsWithSummary } from '../../utils/transactionFunctions'
import { AllApplicationParametersHook, RefApplicationParameterHook } from './ApplicationParametersHooks'
import { AllModelParameterHook, RefModelParameterHook } from './ModelParameterHooks'
import { AccountsHook, ExposuresHook, ForwardCoveragesHook, OptionCoveragesHook } from './TransactionsHooks'
import { postUserActivity } from '../../GlobalFunctions'
import { RefMarketValueHook, RefSPOT } from './MarketValuesHook'
import { selectAllTransactionsOk } from '../../store/selectors/transactionsSelectors'
import { ScenariosHook } from './ScenariosHook'
import { selectCurrentDate } from '../../store/selectors/applicationSelectors'
import { buildScenarioGenerator } from '../../utils/scenarioFunctions'



// Hook for managing a single transaction summary with summary
export const RefTransactionsSummaryTableHook = ({forcedVisualizationPeriodicity = null, onlyTable = false, onlySummary = false} = { onlyTable : false, onlySummary : false}) => {


  // Transactions
  // ----------------- 
  const exposures = ExposuresHook()
  const fwdCoverages = ForwardCoveragesHook()
  const optionCoverages = OptionCoveragesHook()
  const accounts = AccountsHook()

  // Scenarios
  // ----------------
  const selectedScenarioId = RefApplicationParameterHook(con.SELECTED_SCENARIO)
  const scenarios = ScenariosHook()
  const volatility = RefMarketValueHook(con.MARKET_VOLATILITY)
  const percentile = RefModelParameterHook(con.ESC_CONFIDENCE_LEVEL)
    

  // Parameters
  // ----------------- 
  const spot = RefSPOT()
  const currentDate = useSelector(selectCurrentDate)
  const modelParameters = AllModelParameterHook()
  const modelApplicationParameters = AllApplicationParametersHook()
  const periodicityVisualization = RefApplicationParameterHook(con.VISUALIZATION_PERIODICITY)
  const [localVisualizationPeriodicity, setLocalVisualizationPeriodicity] = useState(() => forcedVisualizationPeriodicity!= null ? forcedVisualizationPeriodicity:periodicityVisualization)

  // Loading Status for the transactions
  const allTransactionLoaded = useSelector(selectAllTransactionsOk);

  // Main Object
  const [transactionSummaryObject, setTransactionSummaryObject] = useState(() => [])

  // Summary Row
  const [summaryRow, setSummaryRow] = useState(() => {})
  
  // Computing Variable
  const [computing, setComputing] = useState(() => true)

  // Has summary table
  const [hasSummaryTable, setHasSummaryTable] = useState(() => false)


  // Computing method
  const computeTransactionSummary = useCallback(
    () => {      

      // Only checks if all transactions have been loaded
      if(allTransactionLoaded)
        {               
          new Promise(function (success) {
              
            setTimeout(async () => {

              const generator = buildScenarioGenerator(
                scenarios[selectedScenarioId],
                {
                  volatility,
                  percentile
                }
              )
              
              // Function for updating the summary (async to not block execution)
              await postUserActivity("check position")

              let [df_trans, sumRow] = await processTransactionsWithSummary(currentDate,
                                                        spot,
                                                        generator,
                                                        modelParameters, 
                                                        exposures,
                                                        fwdCoverages,
                                                        optionCoverages,
                                                        accounts,
                                                        {...modelApplicationParameters, [con.VISUALIZATION_PERIODICITY] : localVisualizationPeriodicity})
              success([df_trans, sumRow])
            
            
            }, con.UI_TIMEOUT);
            
          }).then(([transSumm, sumRow]) => {

                 
            setTransactionSummaryObject(transSumm)
            setSummaryRow(sumRow)
            setHasSummaryTable(transSumm.length > 0)
            setComputing(false)  
          })
    }
    },
    [allTransactionLoaded, exposures, fwdCoverages, optionCoverages, accounts, modelParameters,
     selectedScenarioId, localVisualizationPeriodicity, currentDate, spot, modelApplicationParameters,
     percentile, scenarios, volatility], 
  )
                        
    // Reloads summary object on change
    useEffect(() => {
        
        // Computing
        setComputing(true)
        
        setTimeout(() => {   
          // Computes Transaction           
          computeTransactionSummary()
        }, con.UI_TIMEOUT);            

    }, [computeTransactionSummary])

    // Visualization
    useEffect(() => {
      
        if(forcedVisualizationPeriodicity == null)
           setLocalVisualizationPeriodicity(periodicityVisualization)

    }, [periodicityVisualization, forcedVisualizationPeriodicity])
    
    if(onlyTable)
      return([transactionSummaryObject, computing, hasSummaryTable])

    if(onlySummary)
      return([summaryRow, computing, hasSummaryTable])

    return([transactionSummaryObject, summaryRow, computing, hasSummaryTable])
}

